(function () {
  const MARQUEE_SELECTOR = '.rh-marquee[data-rh-marquee]';

  function debounce(fn, wait) {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  function layoutMarquee(marquee) {
    const track = marquee.querySelector('[data-rh-marquee-track]');
    const viewport = marquee.querySelector('.rh-marquee__viewport');
    const template = marquee.querySelector('[data-rh-marquee-strip]');

    if (!track || !viewport || !template) return;

    track.querySelectorAll('.rh-marquee__strip').forEach((strip, index) => {
      if (index > 0) strip.remove();
    });

    const minWidth = viewport.offsetWidth * 2;
    let stripCount = 1;

    while (track.scrollWidth < minWidth && stripCount < 24) {
      const clone = template.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('data-rh-marquee-strip');
      track.appendChild(clone);
      stripCount += 1;
    }

    track.style.setProperty('--rh-marquee-shift', `${100 / stripCount}%`);
  }

  function initMarquees() {
    document.querySelectorAll(MARQUEE_SELECTOR).forEach(layoutMarquee);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMarquees);
  } else {
    initMarquees();
  }

  window.addEventListener('load', initMarquees);
  window.addEventListener('resize', debounce(initMarquees, 150));

  document.addEventListener('shopify:section:load', (event) => {
    const marquee = event.target.querySelector?.(MARQUEE_SELECTOR);
    if (marquee) layoutMarquee(marquee);
  });
})();
